import type { ReactNode } from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import styles from "./SupplementalResponseLayout.module.scss";

interface SupplementalResponseLayoutProps {
  sidebar: ReactNode;
  documentTitle: string;
  children: ReactNode;
  footer?: ReactNode;
}

export default function SupplementalResponseLayout(
  props: SupplementalResponseLayoutProps,
) {
  return (
    <Container className={`page-container ${styles.pageContainer}`}>
      <div
        data-testid="breadcrumbs"
        className={`bread-crumbs ${styles.breadcrumbs}`}
      >
        <Link to="/documents">Document List</Link>
        {" > Supplemental Responses"}
      </div>

      <div className={styles.layout}>
        <div className={styles.header}>
          <h1 data-testid="supplemental-response-title">
            Supplemental Response
          </h1>
          <p>Select the responses you'd like to supplement.</p>
        </div>

        <div className={styles.content}>
          <div className={styles.sidebar}>
            <div className={styles.sidebarTitle}>Responses</div>
            {props.sidebar}
          </div>

          <div className={styles.main}>
            <div data-testid="document-title" className={styles.documentTitle}>
              {props.documentTitle}
            </div>
            {props.children}
          </div>
        </div>

        {props.footer && <div className={styles.footer}>{props.footer}</div>}
      </div>
    </Container>
  );
}
